import { SimpleLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import {
    COMPONENT_CONNECT,
    COMPONENT_DISCONNECT,
    createDispatcher,
} from '@elab/core/utils/dynaReduxHelpers';

import { reducers, sagaFactory, storeName } from './redux';

/**
 * Component is used to choose delivery methods on checkout
 *
 * HTML Structure Example
 *
 * <e2-delivery-group>
 *     html content here
 * </e2-delivery-group>
 */

export class DeliveryGroup extends SimpleLitElement {
    afterConnect() {
        this.dispatchEvent(new CustomEvent(COMPONENT_CONNECT));
    }

    beforeDisconnect() {
        this.dispatchEvent(new CustomEvent(COMPONENT_DISCONNECT));
    }
}

const mapDispatchToEvents = dispatch =>
    createDispatcher({ storeName, reducers, sagaFactory }, dispatch);

export default () =>
    customElements.define('e2-delivery-group', connect(null, mapDispatchToEvents)(DeliveryGroup));
